import S from './Header.module.scss';
import {Link, useNavigate, useLocation, useSearchParams} from 'react-router-dom';
import { useEffect, useState, useMemo, useRef } from 'react';
import _ from 'lodash';
import { AuthUtils } from '../../../utils/AuthUtils';
import { logoutRequest } from '../../../repository/LoginRepository';
import {UrlUtils} from "../../../utils/UrlUtils";

const Header = () => {
  const [visible, setVisible] = useState<boolean>(true);
  const [isHeaderView, setIsHeaderView] = useState<boolean>(true);
  const [searchKeyword, setSearchKeyword] = useState<string>('');
  const [searchParams] = useSearchParams();
  const queryFilters = searchParams.get('filters');
  const queryKeyword = searchParams.get('keyword');

  const { pathname } = useLocation();

  // 스크롤 이벤트 감지
  const beforeScrollY = useRef(0);
  const isLogin = AuthUtils.isLoggedIn();
  const token = AuthUtils.getCookie('token');
  const navigate = useNavigate();

  const userLogout = () => {
    logoutRequest(token)
      .then((res) => {
        AuthUtils.removeCookie('token');
        navigate('/');
        //refresh
        navigate(0);
      })
      .catch((e) => console.error(e));
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (pathname === '/login') {
      setIsHeaderView(false);
    }
    setSearchKeyword(queryKeyword || '');
  }, [pathname, searchParams]);

  const handleScroll = useMemo(
    () =>
      _.throttle(() => {
        const currentScrollY = window.scrollY;
        if (beforeScrollY.current < currentScrollY) {
          setVisible(false);
        } else {
          setVisible(true);
        }
        beforeScrollY.current = currentScrollY;
      }, 250),
    [beforeScrollY],
  );

  return (
    <>
      <header style={isHeaderView ? { display: 'block' } : { display: 'none' }}>
        <div
          className={`${S.header} wrapper`}
          style={visible === true ? { height: '19rem' } : { height: '12rem' }}
        >
          <div
            className={S.header_first_wrap}
            style={visible !== true ? { padding: '2rem 0 1rem' } : { padding: '4.8rem 0 2.2rem' }}
          >
            <div
              className={S.sub_menu}
              style={
                visible !== true ? { display: 'flex', marginBottom: '0.8rem' } : { display: 'none' }
              }
            >
              <ul>
                {isLogin ? (
                  <li>
                    <button onClick={() => userLogout()}>
                      <h4 className="button-l">로그아웃</h4>
                    </button>
                  </li>
                ) : (
                  <>
                    <li>
                      <h4 className="button-l">
                        <Link to="/login">로그인</Link>
                      </h4>
                    </li>
                    {/*TODO :: 2th spec */}
                    {/*<li>*/}
                    {/*  <h4 className="button-l">*/}
                    {/*    <Link to="/">회원가입</Link>*/}
                    {/*  </h4>*/}
                    {/*</li>*/}
                  </>
                )}
              </ul>
              {/*TODO :: 2th spec */}
              {/*<button>*/}
              {/*  <h4 className="button-l">기업회원</h4>*/}
              {/*  <div className={S.down_arrow_img}></div>*/}
              {/*</button>*/}
            </div>
            <div className={S.main_search_area}>
              <h1 className={S.logo}>
                <Link to="/">아이비리거</Link>
              </h1>
              <div className={S.top_search_area}>
                <input
                  type="search"
                  placeholder="검색어를 입력해 주세요."
                  value={searchKeyword}
                  onChange={(e) => {
                    setSearchKeyword(e.target.value);
                  }}
                  onKeyDown={(e) => {
                    if(e.key === 'Enter'){
                      navigate(UrlUtils.changeSearchCondition(queryFilters, searchKeyword))
                    }
                  }}
                />
                <button className={S.search_icon} onClick={() => {
                  navigate(UrlUtils.changeSearchCondition(queryFilters, searchKeyword));
                }}></button>
              </div>
              {/* <button className={S.detail_search}>
                <p className="button-l">상세검색</p>
              </button> */}
            </div>
          </div>
          <div
            className={S.header_second_wrap}
            style={visible === true ? { top: '12rem' } : { top: '-7rem' }}
          >
            <div className={S.main_menu}>
              <ul>
                <li>
                  <h4 className="h4">
                    <Link to="/recruitment">채용공고</Link>
                  </h4>
                </li>
                <li>
                  <h4 className="h4">
                    <Link to="/resume">이력서</Link>
                  </h4>
                </li>
              </ul>
            </div>
            <div className={S.sub_menu}>
              <ul>
                {isLogin ? (
                  <li>
                    <button onClick={() => userLogout()}>
                      <h4 className="button-l">로그아웃</h4>
                    </button>
                  </li>
                ) : (
                  <>
                    <li>
                      <h4 className="button-l">
                        <Link to="/login">로그인</Link>
                      </h4>
                    </li>
                    {/*TODO :: 2th spec */}
                    {/*<li>*/}
                    {/*  <h4 className="button-l">*/}
                    {/*    <Link to="/">회원가입</Link>*/}
                    {/*  </h4>*/}
                    {/*</li>*/}
                  </>
                )}
              </ul>
              {/*TODO :: 2th spec */}
              {/*<button>*/}
              {/*  <h4 className="button-l">기업회원</h4>*/}
              {/*  <div className={S.down_arrow_img}></div>*/}
              {/*</button>*/}
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
